import Classes from "@/views/Classes";
import CreateClass from "@/components/classes/CreateClass";
import EditClass from "@/components/classes/EditClass";
import ImportClasses from "@/components/classes/ImportClasses";
import ClassDetails from "@/views/ClassesDetails";
import ClassInvite from "@/views/ClassInvite";
import OrganizationTeam from "@/views/OrganizationTeam";
import ReportRolePlay from "@/views/ReportRolePlay";

const classesRoutes = [
  {
    path: "/organization/:organizationId/classes",
    name: "classes",
    component: OrganizationTeam,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Classes'
    }
  },
  {
    path: "/organization/:organizationId/teams/new",
    name: "classes-new",
    component: CreateClass,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Create Class'
    }
  },
  {
    path: "/organization/:organizationId/classes/import",
    name: "classes-import",
    component: ImportClasses,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Import Class'
    }
  },
  {
    path: "/organization/:organizationId/classes/:classId",
    name: "class-details",
    component: ClassDetails,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Class Details'
    }
  },
  {
    path: "/organization/:organizationId/classes/:classId/invite",
    name: "class-invite",
    component: ClassInvite,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Invite Class'
    }
  },
  {
    path: '/organization/:organizationId/classes/:classId/edit',
    name: 'class-edit',
    component: EditClass,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Edit Class'
    }
  },
  {
    path: '/organization/:organizationId/classes/:classId/report-role-play',
    name: 'report-role-play',
    component: ReportRolePlay,
    props: true,
    meta: {
      menuItemIndex: '3',
      title:'Report Role Play'
    }
  }
];

export default classesRoutes;
